export const HRM_PATHS = {
  ROOT: "/hrm",
  EMPLOYEE_MANAGEMENT: "/hrm/employee-information",
  EMPLOYEE_PROFILE: "/hrm/employees/:userId",
  MY_PROFILE: "/hrm/employees/me",
  ANNUAL_LEAVE: "/hrm/annual-leave",
  ANNUAL_LEAVE_APPLICATION_DETAIL: "/hrm/annual-leave-application-detail/:id",
  APPLICATION_CREATE_FORM: "/hrm/application-create-form",
  APPLICATION_REQUESTS: "/hrm/application-requests",
  AUTHZ_JOB_TITLES: "/hrm/role-management/job-titles",
  AUTHZ_ROLES: "/hrm/role-management/roles",
  AUTHZ_GRANTS: "/hrm/role-management/grants",
  ORG_COMPANY_GROUPS: "/hrm/org/company-groups",
  ORG_COMPANIES: "/hrm/org/companies",
  ORG_DEPARTMENT_FUNCTIONS: "/hrm/org/department-functions",
  ORG_BRANCHES: "/hrm/org/branches",
  ORG_DEPARTMENTS: "/hrm/org/departments",
  ORG_TEAMS: "/hrm/org/teams",
  ROLE_MANAGEMENT: "/hrm/role-management",
  CONTRACTS: "/hrm/contracts",
  ASSIGNMENTS: "/hrm/assignments",
};

export const MTC_PATHS = {
  ROOT: "/mtc",
};

export const PUBLIC_PATHS = {
  ACCESS_LOGGING: "public/access-logging",
  CHECKIN_CHECKOUT: "public/check-in-check-out",
};

export const MASTER_PATHS = {
  ROOT: "/master",
  APPROVAL_SETTINGS: "/master/approval-settings",
  CUSTOMER_ACCOUNT_MANAGEMENT: "/master/customer-accounts",
  PAYEE_REGISTER: "/master/payees/register",
  CARRIER_REGISTER: "/master/carriers/register",
  SHIPPER_PAGE: "/master/shippers",
  CNEE_PAGE: "/master/cnees",
  CARRIER_PAGE: "/master/carriers",
  MASTER_FORM_PAGE: "/master/forms",
  MASTER_FORM_REGISTER: "/master/forms/register",
  MASTER_FORM_DETAIL: "/master/forms/:id",
  LOCATION_ADDRESS: "/master/location-address-management",
  MASTER_APPROVAL_SETTINGS: "/master/approval-settings",
};

export const SHIPMENT_PATHS = {
  ROOT: "/shipments",
  ROOT_DETAIL: "/shipments/detail/",
  CDS: "/shipments/cds",
  IMPORT_DATA_CDS_INVOICE_COST: "/cost/cds-import-data",
  CONTAINER: "/shipments/container",
  SPEACIALIZED_LICENSE_INFOMATION: "/shipments/specialized-license-information",
  IMPORT_DATA: "/shipments/import-data",
  IMPORT_DATA_CONTAINER: "/shipments/container/import-data",
  ASSIGNMENT_TRUCKING: "/shipments/container/assignment-trucking",
  COST: "/cost",
  COST_DETAIL: "/cost/detail/",
  IMPORT_DATA_PROJECT_INVOICE_COST: "/cost/import-data",
  FULL_CDS_LIST: "/shipments/view-list-cds-export",
  FULL_LIST_CONTAINER: "/shipments/list-container-export",
};

export const NEW_SHIPMENT_PATHS = {
  ROOT: "/new-shipments",
  CREATE: "/new-shipments?action=create",
  CDS: "/new-shipments/cds",
  UPLOAD_CDS: "/new-shipments/cds/upload",
  TRUCKING: "/new-shipments/truckings",
  TRUCKING_PLAN: "/new-shipments/trucking-plans",
  BILL: "/new-shipments/bills",
  COST: "/new-shipments/costs",
  NEW_LICENSE: "/new-shipments/licenses",
  MASTER_CDS_ACTION: "/new-shipments/settings/cds-actions",
  MASTER_TRUCKING_ACTION: "/new-shipments/settings/trucking-actions",
  SHIPMENT_RECEIVABLE_DETAIL: "/new-shipments/:shipmentId/shipment-receivable/:receivableId",
  SHIPMENT_COST_FORM_SETTINGS: "/new-shipments/settings/cost-form",
  SHIPMENT_COST_SETTINGS: "/new-shipments/cost-settings/cost-form",
  REVENUE: "/new-shipments/revenue",
};

export const REPORTS_PATH = {
  ROOT: "/reports",
  SHIPMENT_REPORT: "/reports/shipments",
  COST_REPORT: "/reports/costs",
  RECEIVABLES_PNL: "/reports/receivables-pnl",
};

export const ROADMAP_PATHS = {
  ROOT: "/roadmap",
};

export const GUIDLINE_PATHS = {
  ROOT: "/posts",
  ADMIN: "/posts/admin",
  ADMIN_CREATE: "/posts/create",
  ADMIN_DETAIL: "/posts/admin",
};

export const DASHBOARD_REPORT = {
  ROOT: "/dashboard",
};

export const MASTER_FORM = {
  ROOT: "/form/create",
  FORM: "/forms",
  MY_APPLICATION: "/my-applications",
  SENT_TO_ME: "/applications-sent-to-me",
};

export const ADC_COST = {
  ROOT: "/adc-costs",
  EXPENSE_CATEGORY: "/adc-costs/expense-category",
  PAYMENT_REQUEST: "/adc-costs/payment-request",
  ADVANCE_PAYMENT: "/adc-costs/advance-payment",
  CHARGE_BACK: "/adc-costs/charge-back",
  EXTRA_COST: "/adc-costs/extra",
};

export const CRM_PATHS = {
  ROOT: "/crm/customer",
  CONTRACT: "/crm/customer/contract",
};

export const NOTIFICATIONS_PATHS = {
  ROOT: "/notifications",
};

export const MESSAGES_PATHS = {
  ROOT: "/messages",
};

export const TMS_PATHS = {
  ROOT: "/tms",
  VENDOR: "/tms/vendor",
  VENDOR_DETAIL: "/tms/vendor/:type/:id",
  FLEET_MANAGEMENT: "/tms/fleet-management",
  TRUCKING_PLAN_DISPATCH: "/tms/trucking-plan-dispatch",
  TRUCKING_PLAN_DISPATCH_DETAIL: "/tms/trucking-plan-dispatch/:truckingId",
  SHIPMENT_RECEIVABLE_COST_DETAIL: "/tms/trucking-plan-dispatch/costs/shipment-receivables/:costId",
  TMS_OPERATING_COST_DETAIL: "/tms/trucking-plan-dispatch/costs/tms-operating/:costId",
  TRUCKING: "/tms/truckings",
  TRUCKING_DETAIL: "/tms/truckings/:id",
  DIEU_HANH_TRUCKING: "/tms/trucking-plan-dispatch",
  COST_OVERVIEW: "/tms/trucking-plan-dispatch?tab=cost&costKind=SHIPMENT_RECEIVABLE",
  TRIP_PNL_OVERVIEW: "/tms/trucking-plan-dispatch?tab=cost&costKind=PNL",
  TRUCKING_ACTION_SETTING: "/tms/settings/trucking-actions",
  COST_APPROVAL_SETTING: "/tms/cost-approval-setting",
};
